import React from 'react';
// import {useResourceContext} from 'components/record/ResourceContext';
import {CloudDownload} from '@mui/icons-material';
import {Button} from './Buttons';
import {RecordType, SingleRecord} from 'components/record/RecordContext';
import {useResourceContext} from 'components/record/ResourceContext';
import {downloadCSV, recordsToCsv} from 'services/utils';
import {useListContext} from 'components/list/ListContext';

const BulkExport = (props: BulkExportProps) => {
  const {selected: ids, list: data} = useListContext();
  const {resource} = useResourceContext();
  const {label = 'Export', transformProperties, ...rest} = props;

  const transform = (item: RecordType) => {
    if (!transformProperties) {
      return item;
    }
    const newObject: SingleRecord = {};
    for (const key of transformProperties) {
      newObject[key] = item[key];
    }
    return newObject;
  };

  const handleClick = () => {
    const exportData = data.filter((item) => ids.includes(item.id)).map((item) => transform(item));

    const csv = recordsToCsv(exportData as Array<Record<string, unknown>>);
    downloadCSV(csv, resource);
  };

  return (
    <Button startIcon={<CloudDownload />} variant="text" {...rest} onClick={handleClick}>
      {label}
    </Button>
  );
};

type BulkExportProps = {
  label?: string;
  confirmTitle?: string;
  confirmContent?: React.ReactNode;
  transformProperties?: Array<string>;
};

export default BulkExport;
